import { useState } from 'react';

import {
  Button,
  Checkbox,
  Flex,
  Icons,
  Modal,
  Tag,
  theme,
  Typography,
} from '@contiple/antd-ds';
import { Trans, useTranslation } from 'react-i18next';

import { dismissToday } from '../utils';

const { Text, Title } = Typography;

interface FreeTrialGuideModalProps {
  open: boolean;
  endDate: string;
  dday: number;
  onClose: () => void;
}

export default function FreeTrialGuideModal({
  open,
  endDate,
  dday,
  onClose,
}: FreeTrialGuideModalProps) {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const [dismissChecked, setDismissChecked] = useState(false);

  const handleClose = () => {
    if (dismissChecked) {
      dismissToday();
    }
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      closable={false}
      centered
      width={550}
      styles={{
        content: { padding: 0 },
        body: { padding: '40px 40px 24px' },
        footer: { padding: '24px 32px', marginTop: 0 },
      }}
      footer={
        <Flex justify="space-between" align="center">
          <Checkbox
            checked={dismissChecked}
            onChange={(e) => setDismissChecked(e.target.checked)}>
            {t('dashboard.freeTrialDismissToday')}
          </Checkbox>
          <Button onClick={handleClose}>{t('dashboard.freeTrialClose')}</Button>
        </Flex>
      }>
      <Flex vertical align="center" gap={16}>
        <Flex vertical align="center" gap={12}>
          <Icons.CalendarClock
            size={48}
            style={{ color: token.custom.colorTextAccent }}
          />
          <Flex gap={8} align="center">
            <Title level={5} style={{ margin: 0, textAlign: 'center' }}>
              {t('dashboard.freeTrialTitle')}
            </Title>
            <Tag
              style={{
                margin: 0,
                fontWeight: 600,
                lineHeight: '20px',
                backgroundColor: token.colorText,
                color: token.colorWhite,
                border: 'none',
              }}>
              {t('dashboard.freeTrialDday', { dday })}
            </Tag>
          </Flex>
        </Flex>
        <Text
          type="secondary"
          style={{ textAlign: 'left', whiteSpace: 'pre-line', width: '100%' }}>
          <Trans
            i18nKey="dashboard.freeTrialDesc"
            values={{ endDate }}
            components={[
              <span
                key="date"
                style={{ color: token.custom.colorTextAccent }}
              />,
            ]}
          />
        </Text>
      </Flex>
    </Modal>
  );
}
